import React from 'react';
import { RefreshCw } from 'lucide-react';
import MetricInfoPopover, { MetricInfoDefinition } from './MetricInfoPopover';

interface CardProps {
  title: string;
  value: string | number;
  subValue?: string;
  icon?: React.ReactNode;
  change?: number;
  description?: string;
  loading?: boolean;
  info?: MetricInfoDefinition;
  onClick?: () => void;
  className?: string;
}

const Card: React.FC<CardProps> = ({
  title,
  value,
  subValue,
  icon,
  change,
  description,
  loading = false,
  info,
  onClick,
  className,
}) => {
  return (
    <div 
      onClick={onClick}
      className={`bg-white dark:bg-gray-800 p-4 rounded-lg shadow dark:shadow-gray-900/30 ${onClick ? 'cursor-pointer hover:bg-gray-50/50 dark:hover:bg-gray-700/50 transition-all active:scale-[0.98]' : ''} ${className || ''}`}
    >
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2">
            <p className="text-sm font-semibold text-gray-700 dark:text-gray-300">{title}</p>
            {info && <MetricInfoPopover title={title} info={info} />}
          </div>
          <div className="flex items-baseline gap-1.5 mt-1 flex-wrap">
            {loading ? (
              <div className="flex items-center space-x-2">
                <RefreshCw className="w-4 h-4 animate-spin text-primary-600 dark:text-primary-400" />
                <span className="text-lg font-semibold text-gray-900 dark:text-white">{value}</span>
              </div>
            ) : (
              <span className="text-lg font-semibold text-gray-900 dark:text-white">{value}</span>
            )}
            {subValue && (
              <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">
                {subValue}
              </span>
            )}
            {change !== undefined && (
              <span className={`text-sm font-medium ${change >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>
                {change >= 0 ? '+' : ''}{change}%
              </span>
            )}
          </div>
          {description && (
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>
          )}
        </div>
        {icon && (
          <div className="p-2 bg-gray-100 dark:bg-gray-700 rounded-lg">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card; 
